import { defineElement, FC, onDidLoad, useElement, useListen } from '@atomify/hooks';
import { setupEnergyCostGTM } from '@utilities/woonmodule-gtm';

const WOONCONFIGURATOR_IFRAME_ELEMENT_HOOK = 'js-hook-woonconfigurator-iframe';
const WOONCONFIGURATOR_SCRIPT_WRAPPER_ELEMENT_HOOK = 'js-hook-woonconfigurator-script-wrapper';

const WoonconfiguratorWrapper: FC = () => {
    const iframeEl = useElement<HTMLIFrameElement>(`[${WOONCONFIGURATOR_IFRAME_ELEMENT_HOOK}]`);
    const scriptWrapperElement = useElement<HTMLDivElement>(
        `[${WOONCONFIGURATOR_SCRIPT_WRAPPER_ELEMENT_HOOK}]`,
    );

    let iframeSrc: string;

    onDidLoad(() => {
        iframeSrc = iframeEl.current?.src || '';

        if (scriptWrapperElement.current) {
            setupEnergyCostGTM(scriptWrapperElement.current!);
        }
    });

    useListen(window, 'message', (e) => {
        const { origin } = e;
        if (!iframeEl.current || !origin) return;

        if (iframeSrc.includes(origin)) {
            iframeEl.current.style.height = `${e.data}px`;
        }
    });
};

defineElement('woonconfigurator-wrapper', WoonconfiguratorWrapper);
